import React from 'react';
import classnames from 'classnames';
// import styles from './icons.scss';

const styles = { icon: '' };

export default function Checkmark(props: React.SVGProps<SVGSVGElement>) {

  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      className={classnames(styles.icon, props.className)}
    >
      <path d="M5.5 11.5L10 16L18.25 7.75" stroke="#0078A0" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  );

}
